export const mobileAppUrls = {
    ios: 'https://itunes.apple.com/app/approvalmax/id1439596637',
    android: 'https://play.google.com/store/apps/details?id=com.approvalmax',
} as const;
